import {t} from "@lingui/core/macro";
import {lazy} from "react";

import {color} from "@khanacademy/wonder-blocks-tokens";

import {Layout, ToolCategories, type Tool} from "../types.ts";

import ticketIcon from "@phosphor-icons/core/regular/ticket.svg";

const CoeditingDocumentTool = lazy(
    () => import("../renderers/coediting-document-tool.tsx"),
);

export const exitTicket: Tool = {
    urlSlug: "exit-ticket",
    configName: "teacher-tool-exit-ticket",
    title: () => t`Exit ticket`,
    description: () =>
        t`Create quick end-of-lesson assessments to check student understanding`,
    categories: [
        ToolCategories.Plan,
        ToolCategories.Create,
        ToolCategories.Support,
    ],
    icon: ticketIcon,
    color: color.fadedPurple24,
    layout: Layout.Coeditor,
    extensionOrder: 5,
    activitySlug: "activity-write-exit-ticket-questions",
    reportingLabelId: "write-exit-ticket",
    exportTargets: [
        "print",
        "download-pdf",
        "download-docx",
        "google-drive-docx",
        "microsoft-onedrive-docx",
        "download-pptx",
        "google-drive-pptx",
        "microsoft-onedrive-pptx",
        "google-forms",
    ],
    requestedInputs: [
        {
            description: () => "",
            inputKind: "SINGLE_SELECT",
            label: () => t`Grade level`,
            required: true,
            selectOptions: [
                {
                    label: () => t`1st grade`,
                    value: "1st grade",
                },
                {
                    label: () => t`2nd grade`,
                    value: "2nd grade",
                },
                {
                    label: () => t`3rd grade`,
                    value: "3rd grade",
                },
                {
                    label: () => t`4th grade`,
                    value: "4th grade",
                },
                {
                    label: () => t`5th grade`,
                    value: "5th grade",
                },
                {
                    label: () => t`6th grade`,
                    value: "6th grade",
                },
                {
                    label: () => t`7th grade`,
                    value: "7th grade",
                },
                {
                    label: () => t`8th grade`,
                    value: "8th grade",
                },
                {
                    label: () => t`9th grade`,
                    value: "9th grade",
                },
                {
                    label: () => t`10th grade`,
                    value: "10th grade",
                },
                {
                    label: () => t`11th grade`,
                    value: "11th grade",
                },
                {
                    label: () => t`12th grade`,
                    value: "12th grade",
                },
                {
                    label: () => t`College`,
                    value: "College",
                },
            ],
            variableName: "gradeLevel",
        },
        {
            description: () => t`e.g., Average rate of change of polynomials`,
            inputKind: "TEXT_BOX",
            label: () => t`Lesson topic or learning objective`,
            required: true,
            variableName: "learningObjective",
        },
    ],
    component: ({providedInputs, configName, debugMode}) => {
        return (
            <CoeditingDocumentTool
                configName={configName}
                providedInputs={providedInputs}
                debugMode={debugMode}
            />
        );
    },
};
